// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entities_card_body-module__container--2yqNY{padding:24px 24px 16px}.entities_card_body-module__linkcontainer--vuig6{padding:24px 24px 16px;cursor:pointer}\n", ""]);
// Exports
exports.locals = {
	"container": "entities_card_body-module__container--2yqNY",
	"linkcontainer": "entities_card_body-module__linkcontainer--vuig6"
};
module.exports = exports;
